<template>
  <div>
    Display Content Connector Setup Here...
  </div>
</template>

<script>
export default {
  name: 'ContentConnector',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
